import {useTranslation} from "../../../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
import React, {useCallback, useMemo, useState} from "react";
import {execFn, range} from "../../../common/generic-react.functions.js";
import Button from "../button/button.component.js";
import Icon from "../icon/icon.component.js";
import {PaginationContainer, PaginationContentContainer, PaginationItemContainer} from "./pagination.styles.js";
const MIN_VISIBLE = 7;
function Pagination({
  activePage = 1,
  disabled,
  length = 1,
  nextIcon = "angle-right",
  prevIcon = "angle-left",
  totalVisible = 9,
  onChange
}) {
  const {
    t
  } = useTranslation();
  const [actual, setActual] = useState(activePage);
  const changePage = useCallback((page) => {
    if (!disabled) {
      setActual(page);
      execFn(onChange, page);
    }
  }, [disabled, onChange]);
  const generateItem = useCallback((page) => /* @__PURE__ */ React.createElement(PaginationItemContainer, {
    key: `page__${page}`,
    onClick: () => changePage(page),
    active: actual === page
  }, /* @__PURE__ */ React.createElement(Button, {
    disabled
  }, page)), [actual, changePage, disabled]);
  const calculateItems = useCallback((divider) => {
    const maxLength = Math.min(Math.max(0, Math.min(7, totalVisible)) || length, length);
    const even = maxLength % 2 === 0 ? 1 : 0;
    const left = Math.floor(maxLength / 2);
    const right = length - left + 1 + even;
    if (maxLength < MIN_VISIBLE) {
      return range(1, maxLength);
    } else if (actual > left && actual < right) {
      const start = actual - left + 2;
      const end = actual + left - 2 - even;
      return [1, divider, ...range(start, end), divider, length];
    } else if (actual === left) {
      const end = actual + left - 1 - even;
      return [...range(1, end), divider, length];
    } else if (actual === right) {
      const start = actual - left + 1;
      return [1, divider, ...range(start, length)];
    } else {
      return [...range(1, left), divider, ...range(right, length)];
    }
  }, [actual, length, totalVisible]);
  const generateItems = useCallback(() => {
    const divider = "...";
    return calculateItems(divider).map((x, i) => {
      if (typeof x === "number") {
        return generateItem(x);
      }
      return /* @__PURE__ */ React.createElement("span", {
        key: `separator__${i}`,
        className: "pagination__divider"
      }, x);
    });
  }, [calculateItems, generateItem]);
  const items = useMemo(() => generateItems(), [generateItems]);
  return items?.length ? /* @__PURE__ */ React.createElement(PaginationContainer, {
    role: "navigation",
    "aria-label": t("pagination.label"),
    disabled
  }, /* @__PURE__ */ React.createElement(PaginationContentContainer, null, /* @__PURE__ */ React.createElement(PaginationItemContainer, {
    onClick: () => changePage(Math.max(1, actual - 1))
  }, /* @__PURE__ */ React.createElement(Button, {
    disabled: disabled || actual === 1
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: prevIcon
  }))), items, /* @__PURE__ */ React.createElement(PaginationItemContainer, {
    onClick: () => changePage(Math.min(length, actual + 1))
  }, /* @__PURE__ */ React.createElement(Button, {
    disabled: disabled || actual === length
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: nextIcon
  }))))) : null;
}
export default /* @__PURE__ */ React.memo(Pagination);
